import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";

import LoginButton from "components/LoginButton";
import PasswordTextField from "components/PasswordTextField";
import TextField from "components/TextField";
import { useLogin } from "hooks/apis/auth";

type FormValues = {
  userId: string;
  password: string;
};

const LoginPage = () => {
  const methods = useForm<FormValues>();
  const loginMutation = useLogin();
  const form = methods.watch();

  const onSubmit = (form: FormValues) => {
    loginMutation.mutate(form);
  };

  useEffect(() => {
    loginMutation.reset();
  }, [JSON.stringify(form)]);

  return (
    <div className="flex min-h-full h-fit">
      <div className="w-[33.33%] bg-primary" />
      <div className="py-[16.875rem] w-[21.563rem] mx-auto">
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormProvider {...methods}>
            <div className="space-y-[1.875rem] mb-[4.438rem]">
              <h1 className="font-bold text-40 text-center">로그인</h1>
              <TextField
                name="userId"
                label="아이디"
                placeholder="아이디를 입력해주세요"
                required
                showError={false}
                maxLength={20}
                pattern={/[^a-zA-Z0-9]/g}
                error={(loginMutation.error as any)?.response?.status === 400}
              />
              <PasswordTextField
                name="password"
                label="비밀번호"
                placeholder="비밀번호를 입력해주세요"
                required
                showError={false}
                maxLength={20}
                error={(loginMutation.error as any)?.response?.status === 400}
                errorMessage={
                  (loginMutation.error as any)?.response?.status === 400
                    ? "아이디 혹은 비밀번호를 정확하게 입력해주세요"
                    : undefined
                }
              />
            </div>
            <LoginButton
              type="submit"
              className="w-full"
              disabled={!methods.formState.isValid}
              color={methods.formState.isValid ? "primary" : "gray"}
            >
              로그인
            </LoginButton>
          </FormProvider>
        </form>
        <hr className="border-secondary my-[1.813rem]" />
        <p className="text-center text-secondary">
          * 아이디/비밀번호 찾기는 관리자에게 문의하세요.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
